import * as React from 'react'
import { useCallback } from 'react'
import Stack from '@mui/material/Stack'
import { LocationLink } from '../../LocationLink'
import { useData } from '../hooks/useData'
import { LocationDTO } from '@sales-center/common'
import Button from '@mui/material/Button'
import { EntityDetail } from '@user/store/map/typings'
import Typography from '@mui/material/Typography'

type Props = {
  entityDetails: EntityDetail | null
  serviceLocation: LocationDTO
  variant: string
  defaultOpen?: boolean
  canUpdate?: boolean
}

function BasicInfo(props: Props) {
  const { entityDetails, serviceLocation, variant } = props

  const { formattedPhone, email } = useData({
    entityDetails,
    serviceLocation,
    variant,
    defaultOpen: props.defaultOpen,
  })

  const onPhoneNumberClick = useCallback(() => {
    if (formattedPhone) {
      window.open(`tel:${formattedPhone}`, '_blank')
    }
  }, [formattedPhone])

  const onEmailClick = useCallback(() => {
    if (email) {
      window.open(`mailto:${email}`, '_blank')
    }
  }, [email])

  return (
    <Stack>
      {formattedPhone ? (
        <Typography
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontWeight: '500',
            alignContent: 'center',
          }}
          variant="subtitle4"
        >
          Phone:
          <Button
            color="primary"
            variant="text"
            size="small"
            onClick={onPhoneNumberClick}
            sx={{
              width: 'fit-content',
              color: '#1565C0',
            }}
            disableElevation
          >
            {formattedPhone}
          </Button>
        </Typography>
      ) : null}

      {email ? (
        <Typography
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontWeight: '500',
            alignContent: 'center',
          }}
          variant="subtitle4"
        >
          Email:
          <Button
            color="primary"
            variant="text"
            size="small"
            onClick={onEmailClick}
            sx={{
              width: 'fit-content',
              color: '#1565C0',
            }}
            disableElevation
          >
            {email}
          </Button>
        </Typography>
      ) : null}

      {serviceLocation?.locationCode && serviceLocation?.externalLinkId && (
        <LocationLink
          externalLocationId={serviceLocation.externalLinkId}
          externalLocationCode={serviceLocation.locationCode}
          billingLocation={false}
          typographyVariant="subtitle4"
          fontSize="14px"
          noIcon
          containerSx={{
            alignContent: 'center',
          }}
          linkButtonSx={{
            minWidth: 'fit-content',
            maxWidth: 'fit-content',
            padding: 0.5,
          }}
        />
      )}
    </Stack>
  )
}

export default BasicInfo
